import { render, staticRenderFns } from "./VirtualPOIList.vue?vue&type=template&id=57baf5b6&scoped=true"
import script from "./VirtualPOIList.vue?vue&type=script&lang=ts"
export * from "./VirtualPOIList.vue?vue&type=script&lang=ts"
import style0 from "./VirtualPOIList.vue?vue&type=style&index=0&id=57baf5b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57baf5b6",
  null
  
)

export default component.exports